import mitt, { Emitter } from 'mitt'

type E = {
  [key: string]: any;
};

const EventBus: Emitter<E> = mitt<E>()
export default EventBus